import { render } from "./WhyUniteCore.vue?vue&type=template&id=f6d7546c&scoped=true"
import script from "./WhyUniteCore.vue?vue&type=script&lang=js"
export * from "./WhyUniteCore.vue?vue&type=script&lang=js"

import "./WhyUniteCore.vue?vue&type=style&index=0&id=f6d7546c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d7546c"]])

export default __exports__